import './App.css';
import HeroImage from './components/HeroImage';
import AtributosMedicos from './components/AtributosMedicos';
import Header from './components/Header'
import SobreMi from './components/SobreMi'
import AfiliacionesMembresias from './components/AfiliacionesMembresias'
import Testimonios from './components/Testimonios';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <HeroImage />
      <AtributosMedicos />
      <SobreMi />
      <AfiliacionesMembresias />
      <Testimonios />
      <Footer />
    </div>
  );
}

export default App;
